<template>
  <div>
    <div class="vx-row" v-if="
      myOrganizations && (myOrganizations.superOrgs.length > 0 ||
        myOrganizations.subOrgs.length > 0)
    ">
      <div v-for="(myOrgs, index) in myOrganizations.superOrgs" :key="'superOrg-' + index"
        class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base" :class="myOrgs.status === 'DEACTIVATED' ? 'hidden' : ''">
        <vx-card v-if="myOrgs.status !== 'DEACTIVATED'" class="org-card overflow-hidden">
          <div class="items-center flex flex-col justify-between" style="min-height: 360px">
            <div>
              <vs-avatar v-if="myOrgs.logo" class="my-4 profile-picture" size="160px"
                :src="constants.s3Bucket + '/organization/logo/' + myOrgs.logo" />
              <vs-avatar v-else class="my-4 profile-picture" size="160px" :src="require('@/assets/images/icons/organization/business_black_36dp.svg')
                " />
              <div v-if="myOrgs.status === 'active'" class="mb-base">
                <h2 class="mb-1">{{ myOrgs.name }}</h2>
                <p>{{ myOrgs.website }}</p>
              </div>
              <div v-else class="mb-base">
                <h2 class="mb-1">{{ myOrgs.name }}</h2>
                <p>{{ myOrgs.website }}</p>
                <!-- <p>You have been assigned as a sub-admin of this organization</p> -->
              </div>
            </div>
            <div>
              <vs-button v-if="!myOrgs.slug" class="mb-base" size="large" color="primary" type="filled"
                @click.stop="manageOrganization(myOrgs._id)">{{ $t('orgDashboard.main.select') }}</vs-button>
              <vs-button v-else class="mb-base" size="large" color="primary" type="filled"
                @click.stop="manageOrganization(myOrgs.slug)">{{ $t('orgDashboard.main.select') }}</vs-button>
              <!-- <vs-row vs-type="flex" vs-justify="center">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <vs-button
                    color="#A9A9A9"
                    type="border"
                    style="border-radius: 6px"
                    >Copy Link</vs-button
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <vs-button
                    color="#A9A9A9"
                    type="border"
                    style="border-radius: 6px"
                    >Statistics</vs-button
                  >
                </vs-col>
              </vs-row> -->
            </div>
          </div>
        </vx-card>
      </div>
      <div v-for="(myOrgs, index) in myOrganizations.subOrgs" :key="'subOrg-' + index"
        class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base" :class="myOrgs.status === 'DEACTIVATED' ? 'hidden' : ''">
        <vx-card class="org-card overflow-hidden" v-if="myOrgs.status !== 'DEACTIVATED'">
          <div class="items-center">
            <vs-avatar v-if="myOrgs.organization[0] && myOrgs.organization[0].logo" class="my-4 profile-picture"
              size="160px" :src="constants.s3Bucket +
                '/organization/logo/' +
                myOrgs.organization[0].logo
                " />
            <vs-avatar v-else class="my-4 profile-picture" size="160px" :src="require('@/assets/images/icons/organization/business_black_36dp.svg')
              " />
            <div v-if="myOrgs.status === 'active'" class="mb-base items-center">
              <h2 class="mb-1">{{ myOrgs.organization[0].name }}</h2>
              <p>{{ myOrgs.organization[0].website }}</p>
            </div>
            <div v-else class="mb-base">
              <h2 class="mb-1">{{ myOrgs.organization[0].name }}</h2>
              <p>{{ myOrgs.organization[0].website }}</p>
              <!-- <p>You have been assigned as an admin of this organization</p> -->
            </div>
            <div v-if="myOrgs.status === 'active'">
              <vs-button v-if="!myOrgs.organization[0].slug" class="mb-base" size="large" color="primary" type="filled"
                @click.stop="manageOrganization(myOrgs.organization[0]._id)">{{ $t('orgDashboard.main.select')
                }}</vs-button>
              <vs-button v-else class="mb-base" size="large" color="primary" type="filled"
                @click.stop="manageOrganization(myOrgs.organization[0].slug)">{{ $t('orgDashboard.main.select')
                }}</vs-button>
            </div>
            <div v-else>
              <vs-button class="mb-base" size="large" color="success" type="filled"
                @click.stop="acceptAdminOrgInvite(myOrgs._id)">{{ $t('orgDashboard.main.acceptInvitation')
                }}</vs-button>
            </div>
            <!-- <vs-row vs-type="flex" vs-justify="center">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-button
                  color="#A9A9A9"
                  type="border"
                  style="border-radius: 6px"
                  >Copy Link</vs-button
                >
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-button
                  color="#A9A9A9"
                  type="border"
                  style="border-radius: 6px"
                  >Statistics</vs-button
                >
              </vs-col>
            </vs-row> -->
          </div>
        </vx-card>
      </div>
    </div>
    <div v-else class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8">
      <img class="lg:w-3/12 w-64" src="@/assets/images/temp-img/empty-organization.svg" />
      <div class="flex flex-col gap-6 justify-center items-center">
        <p class="text-xl text-black font-semibold text-center flex gap-2 flex-col">
          {{ $t('orgDashboard.main.noOrganizationFound') }}<br />
          <span class="font-normal text-slate-600 text-base">{{ $t('orgDashboard.main.noOrganizationSubtext') }}</span>
        </p>
        <router-link to="/organization/create"
          class="py-2 px-4 bg-primary text-slate-950 w-fit rounded-lg text-lg font-semibold">{{
            $t('orgDashboard.main.createOrganization') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants.js";

export default {
  data() {
    return {
      constants,
    };
  },
  computed: {
    myOrganizations() {
      return this.$store.state.organization.myOrganizations;
    },
  },
  methods: {
    acceptAdminOrgInvite(adminId) {
      this.$store
        .dispatch("organization/acceptAdminOrgInvite", { adminId })
        .then((res) => {
          window.location.href = "/my-organizations";
        })
        .catch((err) => {
          throw err;
        });
    },
    manageOrganization(organizationIdORSlug) {
      window.location.href = `/organization/${organizationIdORSlug}/dashboard`;
    },
  },
  created() {
    const payload = {
      email: this.$store.state.auth.user.email,
      userId: this.$store.state.auth.user._id,
    };
    // console.log(payload);
    this.$store
      .dispatch("organization/fetchAllMyOrganizations", payload)
      .catch((err) => {
        throw err;
      });
  },
  beforeCreate() {
    this.$store.commit("UPDATE_PRIMARY_COLOR", "#F2C244");
    this.$vs.theme({
      primary: "#F2C244",
    });
  },
};
</script>

<style scoped></style>
